export function ThrowHTMLStatusAlert(status = "info", message, duration = 5000) {
  var alertClass = "alert-primary";
  switch (status) {
    case "info":
      status = "info";
      break;
    case "success":
      alertClass = "alert-success";
      break;
    case "warning":
      alertClass = "alert-warning";
      break;
    case "error":
      alertClass = "alert-danger";
      break;
  }

  var appStatusAlert = document.createElement("div");
  appStatusAlert.setAttribute(
    "class",
    "alert " + alertClass + " ocn-status-alert fade in " + status + " shadow"
  );
  appStatusAlert.setAttribute("role", "alert");
  appStatusAlert.style.zIndex = "3";
  appStatusAlert.innerText = message;

  document.body.appendChild(appStatusAlert);

  if (duration != null && duration > 0) {
    setTimeout(function () {
      appStatusAlert.parentNode.removeChild(appStatusAlert);
    }, duration);
    document.body.appendChild(appStatusAlert);
  }
  return appStatusAlert;
}
